module.exports = __webpack_public_path__ + "img/posteIcon.b2d36cba.svg";